// import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { Metric } from 'webapp/models-custom';

interface Args {
	model: Metric;
}

export default class MetricLibraryMetricDimensionsComponent extends Component<Args> {
	get dimensionsWithTypes() {
		return this.args.model.dimensions.map((dimension) => {
			return {
				...dimension,
				type: 'Text',
			};
		});
	}

	// @action
	// openContext(_e: PointerEvent) {
	// 	// TODO
	// }
	<template>
		<table id="dimensions-table" class="bigtable bigtable--no-sticky-header">
			<colgroup>
				<col />
				<col />
				<col class="c3" width="32" />
			</colgroup>
			<thead>
				<tr>
					<th>Name</th>
					<th>Type</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{{#each this.dimensionsWithTypes as |dimensionInfo|}}
					<tr>
						<td><strong>{{dimensionInfo.value}}</strong></td>
						<td>{{dimensionInfo.type}}</td>
						<td>
							{{!-- <a class="context" role="button" {{on "click" this.openContext}}>
                        <Common::UiIcon @name="Ellipsis" @size="sm" />
                    </a> --}}
						</td>
					</tr>
				{{/each}}
			</tbody>
		</table>
	</template>
}
